export default {
  title: 'MyLink元宇宙員工 ID申請',
  c1: 'https://mylink.oss-accelerate.aliyuncs.com/myHomeIcon/applyIdBg.png',
  c2: '活動規則',
  c3: '每位CMHK員工限領一個，按申請的先後順序派發',
  c4: '申請後系統會立即派發，14天內可到元宇宙首頁按“新獲得”進入換號頁面替換原有元宇宙ID，如在14天內沒有替換號碼則會自動失效',
  c5: '申請成功',
  c6: '沒有可連接網絡，請重試',
  c7: '員工ID不可重複領取',
  c8: '您不是員工，無法領取',
  C9: '元宇宙ID卡'
}
